var componentRequireContext = require.context("components/funnel/presenter", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
